"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTimes = require("@fortawesome/pro-regular-svg-icons/faTimes");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _excluded = ["label", "defaultValue", "testId", "testIdItems", "testIdIndex", "options"];

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Option = function Option(props) {
  var dataProp = {
    innerProps: _objectSpread({
      'data-testid': props.data.value
    }, props.innerProps)
  };
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, _objectSpread(_objectSpread({}, props), dataProp));
};

var SelectWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .list__menu {\n        z-index: 100;\n    }\n"])));

var Select = function Select(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? {
    label: 'Please Select',
    value: ''
  } : _ref$defaultValue,
      testId = _ref.testId,
      testIdItems = _ref.testIdItems,
      testIdIndex = _ref.testIdIndex,
      options = _ref.options,
      props = _objectWithoutProperties(_ref, _excluded);

  (0, _react.useEffect)(function () {
    if (testId !== undefined) {
      var temp = document.getElementsByClassName('list__single-value');

      if (temp.length > 0) {
        for (var index = 0; index < temp.length; index++) {
          var t1 = temp[index];

          if (testIdIndex >= 0) {
            if (index === testIdIndex) {
              var t2 = document.createAttribute('data-testid');
              t2.value = testIdItems;
              t1.setAttributeNode(t2);
            }
          }

          if (!testIdIndex) {
            var _t = document.createAttribute('data-testid');

            _t.value = testIdItems;
            t1.setAttributeNode(_t);
          }
        }
      } else {
        var _t2 = temp[0];

        var _t3 = document.createAttribute('data-testid');

        _t3.value = testIdItems;

        _t2.setAttributeNode(_t3);
      }
    }
  }, [testId, testIdIndex, testIdItems]);
  return /*#__PURE__*/_react["default"].createElement(SelectWrapper, _extends({
    "data-testid": testId
  }, props), label && /*#__PURE__*/_react["default"].createElement("label", {
    className: "mb-1"
  }, label), /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], _extends({
    components: {
      Option: Option
    },
    className: "w-100",
    classNamePrefix: "list",
    isDisabled: props.disabled,
    defaultValue: defaultValue,
    placeholder: props.placeholder || 'Please Select...',
    options: options
  }, props)));
};

Select.displayName = 'Select';
Select.propTypes = {
  label: _propTypes["default"].string,
  help: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  placeholder: _propTypes["default"].string,
  options: _propTypes["default"].array.isRequired,
  className: _propTypes["default"].string
};
var _default = Select;
exports["default"] = _default;